import { get, put, post } from '@core/request';

// 服务商管理 - 服务商列表
export const partnersApi = data => get('/conference/boss/partners/list', data);

// 服务商管理 - 新增服务商
export const savePartnersApi = data => post('/conference/boss/partners/save', data);

// 服务商管理 - 修改服务商
export const updatePartnersApi = data => post('/conference/boss/partners/update', data);

// 服务商管理 - 保存服务商人员
export const savePartnerUsersApi = data => post('/conference/boss/partnerusers/save', data);

// 服务商管理 - 获取服务商人员列表
export const getPartnerUsersApi = data => get('/conference/boss/partnerusers/list', data);

// 服务商管理 - 修改服务商人员
export const updatePartnerUsersApi = data => post('/conference/boss/partnerusers/update', data);
